import React, { useState } from "react";
import { Box, Flex, Input, InputGroup, Icon, IconButton, useBreakpointValue, Drawer } from "@chakra-ui/react";
import { MdOutlineSearch, MdClose } from "react-icons/md";
import ProfileMenu from "./ProfileMenu";
import SettingsMenu from "./SettingsMenu";
import NotificationMenu from "./NotificationMenu";
import Sidebar from "./Sidebar";
import { ArawaksLogo } from "components/utils/ArawaksLogo";

const SearchBar = () => (
  <Box flex="1" maxW="400px">
    <InputGroup
      startElement={
        <Icon color="dashboard.fg.subtle" fontSize="md">
          <MdOutlineSearch />
        </Icon>
      }
    >
      <Input
        placeholder="Buscar..."
        h="9"
        rounded="pill"
        bg="dashboard.bg.surface"
        border="1.5px solid"
        borderColor="dashboard.border.default"
        fontSize="sm"
        fontWeight="500"
        color="dashboard.fg.default"
        _placeholder={{ color: "dashboard.fg.subtle" }}
        _hover={{ borderColor: "dashboard.border.default" }}
        _focusVisible={{
          borderColor: "dashboard.accent.border",
          boxShadow: "none",
          outline: "none",
        }}
      />
    </InputGroup>
  </Box>
);

const Topbar = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [open, setOpen] = useState(false);

  const mobileTopbar = (
    <Drawer.Root placement="start" size="xs" open={open} onOpenChange={(e) => setOpen(e.open)}>
      <Drawer.Backdrop />

      <Drawer.Trigger asChild>
        <Box cursor="pointer">
          <ArawaksLogo maxW="120px" />
        </Box>
      </Drawer.Trigger>

      <Drawer.Positioner>
        <Drawer.Content bg="dashboard.bg.panel">
          <Drawer.CloseTrigger asChild>
            <IconButton
              aria-label="Cerrar"
              variant="ghost"
              color="dashboard.fg.muted"
              position="absolute"
              top="3"
              right="3"
              zIndex="overlay"
              rounded="lg"
              _hover={{ bg: "dashboard.bg.surfaceMuted" }}
            >
              <MdClose />
            </IconButton>
          </Drawer.CloseTrigger>

          <Drawer.Body p="0">
            <Sidebar onNavigate={() => setOpen(false)} />
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  );

  return (
    <Flex
      as="header"
      align="center"
      justify="space-between"
      gap="4"
      bg="dashboard.bg.panel"
      borderBottomWidth="1px"
      borderBottomColor="dashboard.border.muted"
      px="5"
      h="64px"
      position="sticky"
      top="0"
      zIndex="10"
    >
      {isMobile ? mobileTopbar : <SearchBar />}

      <Flex align="center" gap="1" flexShrink={0}>
        <NotificationMenu />
        <SettingsMenu />
        <ProfileMenu />
      </Flex>
    </Flex>
  );
};

export default Topbar;
